import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "ml-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, "Cancelar", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, "Aceptar", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-phone" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]

import { ref, computed } from "vue";
import { Form } from "vee-validate";
import { extensionSchema } from "@/store/schemas/callData.schema";
import { AuthModule } from "@/store/modules/Auth";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const visible = ref(false);
const extension = computed(() => AuthModule.extension);

const onSubmit = (values: any) => {
	AuthModule.changeExtension(values);
	visible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return false
    ? (_openBlock(), _createBlock(_component_el_popover, {
        key: 0,
        visible: visible.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
        placement: "bottom",
        width: 200
      }, {
        reference: _withCtx(() => [
          _createElementVNode("div", {
            style: {"cursor":"pointer"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (visible.value = true)),
            class: "nav-link nav-item dropdown-toggle"
          }, _hoisted_7)
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Form), {
            onSubmit: onSubmit,
            "validation-schema": _unref(extensionSchema)()
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_base_input, {
                    name: "Extension",
                    label: "Cambiar extensión",
                    "addon-left-icon": "fa fa-sitemap",
                    placeholder: "Extensión",
                    value: _unref(extension)
                  }, null, 8, ["value"])
                ])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_base_button, {
                  size: "sm",
                  type: "danger",
                  class: "mb-3",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_base_button, {
                  size: "sm",
                  type: "default",
                  "native-type": "submit",
                  class: "mb-3"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _: 1
      }, 8, ["visible"]))
    : _createCommentVNode("", true)
}
}

})